var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-e24-nav-bar'),_vm._v(" "),_c('div',{staticClass:"compliance-wizard"},[_c('headerResources',{attrs:{"isAccordions":"true","srcImage":_vm.img,"tall":_vm.tall,"h1":"Title 24 Wizard & Cost Estimator"}}),_vm._v(" "),_c('residentialWizard')],1),_vm._v(" "),_c('v-e24-footer',{attrs:{"build":_vm.build}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f887d94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ComplianceWizard.vue
// module id = null
// module chunks = 